
import './App.css';
import { useEffect } from 'react';
// import { ChakraProvider } from '@chakra-ui/react'
import {Home} from "./components/Home"
import {About} from "./components/About"
import {Skills} from "./components/Skills"
import { Project } from './components/Projects';
import {Contact} from "./components/Contact"
function App() {
  // useEffect(()=>{
  //   document.title="Bhavani"
  // },[])
  return (
    <div className="App">
      <Home/>
      <About/>
      <Skills/>
      <Project/>
      <Contact/>
    </div>
  );
}

export default App;
